import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Layout, { getUserRole } from "../Components/Layout";
import "../pages/AdminLeaveManagement.css";
import axios from "axios";
import {
  DarkBold,
  LightDark,
  LighterBold,
  Lightight,
} from "../Assets/CSS/Text";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AdminLeaveManagement = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [leaveData, setLeaveData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [leaveBalances, setLeaveBalances] = useState({});
  const [loadingBalances, setLoadingBalances] = useState({});
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [actionLoading, setActionLoading] = useState({});
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [fullReason, setFullReason] = useState("");

  const [selectedMonth, setSelectedMonth] = useState(new Date()); // Default to current month
  console.log(" =========clcik ", selectedMonth);
  const [dateDropdownOpen, setDateDropdownOpen] = useState(false);

  console.log("click", dateDropdownOpen);

  const formatMonthYear = (date) => {
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      year: "2-digit",
    })
      .format(date)
      .replace(" ", " ‘"); // Replace space with apostrophe
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleEmployeeClick = (employee) => {
    // If clicked employee is already selected, toggle the display
    if (selectedLeave && selectedLeave.employee === employee) {
      setSelectedLeave(null);
    } else {
      const leaveDetails = leaveData.find(
        (leave) => leave.employee === employee
      );
      setSelectedLeave(leaveDetails);
    }
  };
  const fetchAllLeaves = async () => {
    setLoading(true); // Start loading before fetching
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/leaves`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            pageNumber: 0, // You can make this dynamic later for pagination
            pageSize: 10,
          },
        }
      );
      console.log("this is admin leave managment ", response.data.content);
      setLeaveData(response.data.content); // ✅ sets the actual array
      setTotalPages(response.data.totalPages); // if you plan to use pagination
      console.log("content : ", response.data.content);
      console.log("pagetotal : ", response.data.content);

      console.log("Leave Data:", response.data.totalPages);
    } catch (error) {
      console.error("Error fetching leaves:", error);
    } finally {
      setLoading(false); // Start loading before fetching
    }
  };

  const handleApproveLeave = async (leaveId) => {
    setActionLoading((prev) => ({
      ...prev,
      [leaveId]: { ...(prev[leaveId] || {}), approve: true },
    }));
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/leaves/approve/${leaveId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchAllLeaves(); // Refresh the list after approval
      setSelectedLeave(null); // Close the details view
    } catch (error) {
      console.error("Error approving leave:", error);
    } finally {
      setActionLoading((prev) => ({
        ...prev,
        [leaveId]: { ...(prev[leaveId] || {}), approve: false },
      }));
    }
  };

  const handleRejectLeave = async (leaveId) => {
    setActionLoading((prev) => ({
      ...prev,
      [leaveId]: { ...(prev[leaveId] || {}), reject: true },
    }));
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/leaves/reject/${leaveId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchAllLeaves(); // Refresh the list after rejection
      setSelectedLeave(null); // Close the details view
    } catch (error) {
      console.error("Error rejecting leave:", error);
    } finally {
      setActionLoading((prev) => ({
        ...prev,
        [leaveId]: { ...(prev[leaveId] || {}), reject: false },
      }));
    }
  };

  const getLeaveBalance = async (empId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/leave-balance/${empId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          // params: empId ? { empId } : {},
        }
      );

      // Transform the backend response to match frontend expectations
      return {
        remainingPaidLeaveBalance: response.data.remainingEarnedLeave,
        totalPaidLeaveBalance: response.data.totalAllocatedEarnedLeave,
        remainingSickLeaveBalance: response.data.remainingSickLeave,
        totalSickLeaveBalance: response.data.totalAllocatedSickLeave,
        remainingCasualLeaveBalance: response.data.remainingCasualLeave,
        totalCasualLeaveBalance: response.data.totalAllocatedCasualLeave,
      };
    } catch (error) {
      console.error("Error fetching leave balance:", error);
      throw error;
    }
  };

  const fetchLeaveBalance = async (empId) => {
    if (loadingBalances[empId] || leaveBalances[empId]) return;

    setLoadingBalances((prev) => ({ ...prev, [empId]: true }));

    try {
      const balanceData = await getLeaveBalance(empId);
      console.log("Balance API Response:", balanceData); // Add this line
      setLeaveBalances((prev) => ({
        ...prev,
        [empId]: balanceData,
      }));
    } catch (error) {
      console.error(`Error fetching balance for empId ${empId}:`, error);
    } finally {
      setLoadingBalances((prev) => ({ ...prev, [empId]: false }));
    }
  };

  useEffect(() => {
    fetchAllLeaves();
  }, []);

  const filteredLeaves = leaveData.filter((leave) => {
    const matchesSearch =
      leave.empFullName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      false;
    // const filteredLeaves = leaveData.filter((leave) => {
    //   const matchesSearch = leave.empFullName?.toLowerCase().includes(searchQuery.toLowerCase()) || false;
    //   // Status filter (fixed to match your data)
    const matchesStatus =
      statusFilter === "All" ||
      (statusFilter === "Pending" && leave.leaveStatus === "PENDING") ||
      (statusFilter === "Approved" && leave.leaveStatus === "APPROVED") ||
      (statusFilter === "Rejected" && leave.leaveStatus === "REJECTED");

    // Date filter
    const leaveDate = new Date(leave.startDate);
    const matchesDate = true;
    // leaveDate.getMonth() === selectedMonth.getMonth() &&
    // leaveDate.getFullYear() === selectedMonth.getFullYear();

    return matchesSearch && matchesStatus && matchesDate;
  });

  const handleViewClick = async (leave) => {
    // If clicked leave is already selected, toggle the display
    console.log("View clicked for empId:", leave.empId);
    console.log("Full leave object:", leave);
    if (selectedLeave && selectedLeave.leaveId === leave.leaveId) {
      setSelectedLeave(null);
    } else {
      setSelectedLeave(leave);
      await fetchLeaveBalance(leave.empId);
    }
  };

  // const getUserRole = () => {
  //   const roles = localStorage.getItem("roles"); // Assume roles are stored in localStorage
  //   return roles ? roles.split(",") : []; // Return roles as an array
  // };

  // const roles = getUserRole();

  const token = localStorage.getItem("token");
  const { roles = [] } = getUserRole(token); // default to empty array

  const isAdmin = roles.includes("ROLE_ADMIN");
  const isManager = roles.includes("ROLE_MANAGER");

  return (


    < div className="adminleave-content" >
      <h2>Leave Requests</h2>

      <div className="filters d-flex justify-content-between "
        style={{ borderBottom: '2px solid #DBDBDB' }} >

        <div className="mb-3">
          {/* Desktop view — show buttons */}
          <div className="d-none d-md-flex gap-2 flex-wrap align-items-center justify-content-between">
            <div className="search-bar2 d-flex align-items-center gap-2">
              <input
                type="text"
                className="text-decoration-none"
                placeholder="Search employee name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Icon
                icon="iconamoon:search"
                width="20"
                height="20"
                color="rgba(0, 175, 239, 1)"
              />
            </div>

            <div className="d-flex gap-2 flex-wrap">
              {["All", "Pending", "Approved", "Rejected"].map((status) => {
                // const count =
                //   status === "All"
                //     ? leaveData.length
                //     : leaveData.filter((item) => item.status === status).length;
                const count =
                  status === "All"
                    ? leaveData.length
                    : leaveData.filter((item) =>
                      (status === "Pending" && item.leaveStatus === "PENDING") ||
                      (status === "Approved" && item.leaveStatus === "APPROVED") ||
                      (status === "Rejected" && item.leaveStatus === "REJECTED")
                    ).length;
                return (
                  <button
                    key={status}
                    className={`tab-btn ${statusFilter === status ? "active" : ""}`}
                    onClick={() => setStatusFilter(status)}
                  >
                    {status} ({count})
                  </button>
                );
              })}
            </div>
          </div>

          {/* Mobile view — stacked layout */}
          <div className="d-md-none mt-2">
            {/* Search bar */}
            <div className="search-bar2 mb-2 d-flex align-items-center gap-2">
              <input
                type="text"
                className="text-decoration-none"
                placeholder="Search employee name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ flex: 1 }}
              />
              <Icon
                icon="iconamoon:search"
                width="20"
                height="20"
                color="rgba(0, 175, 239, 1)"
              />
            </div>

            {/* Dropdown aligned to right */}
            <div className="text-end">
              <select
                className="form-select d-inline-block"
                style={{ width: "144px" }}
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                {["All", "Pending", "Approved", "Rejected"].map((status) => {
                  const count =
                    status === "All"
                      ? leaveData.length
                      : leaveData.filter((item) =>
                        (status === "Pending" && item.leaveStatus === "PENDING") ||
                        (status === "Approved" && item.leaveStatus === "APPROVED") ||
                        (status === "Rejected" && item.leaveStatus === "REJECTED")
                      ).length;
                  return (
                    <option key={status} value={status}>
                      {status} ({count})
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
      </div>
      {
        loading ? (
          isMobile ? (
            // Mobile skeleton cards
            Array.from({ length: 5 }).map((_, index) => (
              <div className="leave-card" key={index}>
                <div className="leave-card-header">
                  <Skeleton width={80} height={16} />
                  <Skeleton
                    width={60}
                    height={16}
                    style={{ float: "right" }}
                  />
                </div>
                <h3>
                  <Skeleton width={120} />
                </h3>
                <p className="leave-type">
                  <Skeleton width={80} />
                </p>
                <p className="leave-reason">
                  <Skeleton count={2} />
                </p>
                <p>
                  <Skeleton width={100} />
                </p>
              </div>
            ))
          ) : (
            // Desktop skeleton table with headers + fake rows
            <div className="table-responsive">
              <table className="leave-table">
                <thead>
                  <tr>
                    <th style={LighterBold}>Employee</th>
                    <th style={LighterBold}>Leave Type</th>
                    <th style={LighterBold}>Date (From–To)</th>
                    <th style={LighterBold}>Reason</th>
                    <th style={{ ...LighterBold, textAlign: "center" }}>
                      Status
                    </th>
                    {roles.includes("ROLE_MANAGER") && (
                      <th style={LighterBold}>Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 5 }).map((_, index) => (
                    <tr key={index} style={{ height: "60px" }}>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Skeleton circle width={36} height={36} />
                          <Skeleton width={120} height={18} />
                        </div>
                      </td>
                      <td>
                        <Skeleton width={90} height={16} />
                      </td>
                      <td>
                        <Skeleton width={140} height={16} />
                      </td>
                      <td>
                        <Skeleton width={180} height={16} />
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Skeleton width={70} height={20} />
                      </td>
                      {roles.includes("ROLE_MANAGER") && (
                        <td>
                          <Skeleton width={60} height={20} />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        ) : filteredLeaves.length === 0 ? (
          <div className="no-leaves-message">
            <p style={{ textAlign: "center", padding: "20px", color: "#999" }}>
              No {statusFilter.toLowerCase()} leave requests available
            </p>
          </div>
        ) : isMobile ? (
          // MOBILE VIEW: Render as cards
          <>
            {filteredLeaves.map((leave, index) => (
              <div className="leave-card" key={index}>
                <div className="leave-card-header">
                  <div>
                    {new Date(leave.appliedDate).toLocaleDateString()}
                  </div>
                  <span
                    className={`status-tag ${leave.leaveStatus.toLowerCase()}`}
                  >
                    {leave.leaveStatus}
                  </span>
                </div>
                <h3>{leave.empFullName}</h3>
                <p className="leave-type">{leave.leaveType}</p>
                <p
                  className="leave-reason"
                  style={{
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    ...Lightight,
                  }}
                >
                  {leave.reason}
                </p>



                <p>
                  Date Applied:{" "}
                  {new Date(leave.appliedDate).toLocaleDateString("en-GB")}
                </p>
                {/* <p>Date From: {new Date(leave.startDate).toLocaleDateString("en-GB")}</p> */}
                {/* <p>Date From:   {leave.startDate} to {leave.endDate}</p> */}
                <p>
                  Date From:{" "}
                  {new Date(leave.startDate).toLocaleDateString("en-GB")} to{" "}
                  {new Date(leave.endDate).toLocaleDateString("en-GB")}
                </p>

                {leave.leaveStatus === "PENDING" && isManager && (
                  <div className="card-actions">
                    {roles.includes("ROLE_MANAGER") && (
                      // <button className="reject-btn" onClick={() => handleRejectLeave(leave.leaveId)}>Reject</button>
                      <button
                        className="reject-btn btn btn-danger"
                        onClick={() => handleRejectLeave(leave.leaveId)}
                        disabled={actionLoading[leave.leaveId]?.reject}
                      >
                        {actionLoading[leave.leaveId]?.reject ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Rejecting...
                          </>
                        ) : (
                          "Reject"
                        )}
                      </button>
                    )}
                    {roles.includes("ROLE_MANAGER") && (
                      // <button className="approve-btn" onClick={() => handleApproveLeave(leave.leaveId)}>Approve</button>
                      <button
                        className="approve-btn btn btn-success"
                        onClick={() => handleApproveLeave(leave.leaveId)}
                        disabled={actionLoading[leave.leaveId]?.approve}
                      >
                        {actionLoading[leave.leaveId]?.approve ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Approving...
                          </>
                        ) : (
                          "Approve"
                        )}
                      </button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          // DESKTOP VIEW: Render as table
          <>
            <table className="leave-table">
              <thead>
                <tr>
                  <th style={LighterBold}>Employee</th>
                  <th style={LighterBold}>Leave Type</th>
                  <th style={LighterBold}>Date (From–To)</th>
                  <th style={LighterBold}>Reason</th>
                  <th style={{ ...LighterBold, textAlign: "center" }}>
                    Status
                  </th>
                  {(isAdmin || isManager) && (
                    <th style={{ ...LighterBold }}>View</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {filteredLeaves.map((leave, index) => (
                  <React.Fragment key={index}>
                    <tr className="clickable-row">
                      <td
                        onClick={() => handleEmployeeClick(leave.empFullName)}
                        style={{ ...DarkBold, cursor: "pointer" }}
                      >
                        {leave.empFullName
                          ? leave.empFullName.charAt(0).toUpperCase() +
                          leave.empFullName.slice(1)
                          : "N/A"}
                      </td>
                      <td style={LightDark}>{leave.leaveType}</td>
                      <td style={LightDark}>
                        {leave.startDate} to {leave.endDate}
                      </td>

                      <td style={{ textAlign: "left", verticalAlign: "top", padding: "8px" }}>
                        <div
                          style={{
                            whiteSpace: "pre-wrap",     // preserve line breaks
                            wordWrap: "break-word",
                            maxWidth: "300px",
                            maxHeight: "150px",         // fixed height for scroll area
                            overflowY: "auto",          // enables vertical scrolling
                            overflowX: "hidden",
                            padding: "4px",
                            ...Lightight,
                          }}
                        >
                          {leave.reason}
                        </div>
                      </td>

                      <td style={{ textAlign: "center" }}>
                        <span
                          className={`status-badge ${leave.leaveStatus === "APPROVED"
                            ? "approved"
                            : leave.leaveStatus === "REJECTED" || leave.leaveStatus === "CANCELLED"
                              ? "rejected"
                              : "pending"
                            }`}
                        >
                          <Icon
                            className="icon"
                            icon={
                              leave.leaveStatus === "PENDING"
                                ? "mdi:clock-outline"
                                : leave.leaveStatus === "APPROVED"
                                  ? "mdi:check-circle-outline"
                                  : "mdi:close-circle-outline"
                            }
                            width="18"
                            height="18"
                          />
                          {leave.leaveStatus}
                        </span>
                      </td>
                      {(isAdmin || isManager) && (
                        <td>
                          <button
                            className="view-button"
                            onClick={() => handleViewClick(leave)}
                          >
                            View
                          </button>
                        </td>
                      )}
                    </tr>

                    {selectedLeave &&
                      selectedLeave.leaveId === leave.leaveId && (
                        <tr>
                          <td colSpan={6}>
                            {/* Your expanded leave-details-card code here */}
                            {/* ... */}
                            <div className="leave-details-card">
                              <button
                                className="close-popup-btn"
                                onClick={() => setSelectedLeave(null)}
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <Icon
                                  icon="mdi:close"
                                  width={20}
                                  height={20}
                                />
                              </button>
                              <div className="header-details">
                                {leave.empPhoto ? (
                                  <img
                                    src={leave.empPhoto}
                                    alt={leave.empFullName}
                                    className="profile-img"
                                  />
                                ) : (
                                  <div className="profile-placeholder">
                                    {leave.empFullName?.charAt(0) || "?"}
                                  </div>
                                )}
                                <div>
                                  <h3>{leave.empFullName}</h3>
                                  <p>
                                    {leave.designation}  {leave.department}
                                  </p>
                                </div>
                              </div>

                              <div className="leave-balance-section">
                                <h4>Leave Balance</h4>
                                {loadingBalances[leave.empId] ? (
                                  <div className="balance-grid">
                                    <div className="balance-item">
                                      <Skeleton
                                        width={60}
                                        height={20}
                                        style={{ marginBottom: 4 }}
                                      />
                                      <Skeleton width={50} height={14} />
                                    </div>
                                    <div className="balance-item">
                                      <Skeleton
                                        width={60}
                                        height={20}
                                        style={{ marginBottom: 4 }}
                                      />
                                      <Skeleton width={50} height={14} />
                                    </div>
                                    <div className="balance-item">
                                      <Skeleton
                                        width={60}
                                        height={20}
                                        style={{ marginBottom: 4 }}
                                      />
                                      <Skeleton width={50} height={14} />
                                    </div>
                                  </div>
                                ) : (
                                  <div className="balance-grid">
                                    <div className="balance-item">
                                      <div className="balance-value">
                                        {leaveBalances[leave.empId]
                                          ?.remainingPaidLeaveBalance ||
                                          0}{" "}
                                        /{" "}
                                        {leaveBalances[leave.empId]
                                          ?.totalPaidLeaveBalance || 0}
                                      </div>
                                      <div className="balance-label">
                                        Paid Leaves
                                      </div>
                                    </div>
                                    <div className="balance-item">
                                      <div className="balance-value">
                                        {leaveBalances[leave.empId]
                                          ?.remainingSickLeaveBalance ||
                                          0}{" "}
                                        /{" "}
                                        {leaveBalances[leave.empId]
                                          ?.totalSickLeaveBalance || 0}
                                      </div>
                                      <div className="balance-label">
                                        Sick Leaves
                                      </div>
                                    </div>
                                    <div className="balance-item">
                                      <div className="balance-value">
                                        {leaveBalances[leave.empId]
                                          ?.remainingCasualLeaveBalance ||
                                          0}{" "}
                                        /{" "}
                                        {leaveBalances[leave.empId]
                                          ?.totalCasualLeaveBalance || 0}
                                      </div>
                                      <div className="balance-label">
                                        Casual Leaves
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="leave-request-details">
                                <div className="detail-row leaveRequest">
                                  <span className="detail-label">
                                    Leave Request:
                                  </span>
                                  <span className="detail-value">
                                    {new Date(
                                      leave.appliedDate
                                    ).toLocaleDateString()}
                                  </span>
                                </div>
                                <div className="detail-row">
                                  <span className="detail-label">
                                    Leave Type:
                                  </span>
                                  <span className="detail-value">
                                    {leave.leaveType}
                                  </span>
                                </div>
                                <div className="detail-row">
                                  <span className="detail-label">
                                    Date (From-To):
                                  </span>
                                  <span className="detail-value">
                                    {leave.startDate} to {leave.endDate}
                                  </span>
                                </div>
                                <div className="detail-row">
                                  <span className="detail-label">
                                    Reason:
                                  </span>
                                  <span className="detail-value reason-text">
                                    <div
                                      style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,        // 👈 only 2 lines
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {leave.reason}
                                    </div>

                                    {leave.reason?.length > 80 && (
                                      <span
                                        style={{
                                          color: "#007bff",
                                          cursor: "pointer",
                                          fontSize: "12px",
                                          marginLeft: "5px"
                                        }}
                                        onClick={() => {
                                          setFullReason(leave.reason);
                                          setShowReasonModal(true);
                                        }}
                                      >
                                        Read More
                                      </span>
                                    )}
                                  </span>
                                </div>
                                <div className="detail-row">
                                  <span className="detail-label">
                                    Status:
                                  </span>
                                  <span
                                    className={`status-value ${leave.leaveStatus.toLowerCase()}`}
                                  >
                                    {leave.leaveStatus}
                                  </span>
                                </div>
                              </div>

                              {leave.leaveStatus === "PENDING" && isManager && (
                                <div className="action1-buttons">
                                  {/* <button
                                    className="reject-btn"
                                    onClick={() =>
                                      handleRejectLeave(leave.leaveId)
                                    }
                                  >
                                    Reject
                                  </button> */}
                                  <button
                                    className="reject-btn btn btn-danger"
                                    onClick={() =>
                                      handleRejectLeave(leave.leaveId)
                                    }
                                    disabled={
                                      actionLoading[leave.leaveId]?.reject
                                    }
                                  >
                                    {actionLoading[leave.leaveId]?.reject ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Rejecting...
                                      </>
                                    ) : (
                                      "Reject"
                                    )}
                                  </button>
                                  {/* <button
                                    className="approve-btn"
                                    onClick={() =>
                                      handleApproveLeave(leave.leaveId)
                                    }
                                  >
                                    Approve
                                  </button> */}
                                  <button
                                    className="approve-btn btn btn-success"
                                    onClick={() =>
                                      handleApproveLeave(leave.leaveId)
                                    }
                                    disabled={
                                      actionLoading[leave.leaveId]?.approve
                                    }
                                  >
                                    {actionLoading[leave.leaveId]?.approve ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Approving...
                                      </>
                                    ) : (
                                      "Approve"
                                    )}
                                  </button>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            {showReasonModal && (
              <div
                className="modal fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content" style={{ borderRadius: "10px" }}>

                    <div className="modal-header">
                      <h5 className="modal-title">Leave Reason</h5>
                      <button
                        className="btn-close"
                        onClick={() => setShowReasonModal(false)}
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div
                        style={{
                          whiteSpace: "pre-wrap",   // 👈 keeps line breaks
                          wordBreak: "break-word",
                          lineHeight: "1.6",
                        }}
                      >
                        {fullReason}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            )}
          </>
        )
      }
    </div >

  );
};

export default AdminLeaveManagement;
